import { render, staticRenderFns } from "./LayoutTextList.vue?vue&type=template&id=6bdb56b2&"
import script from "./LayoutTextList.vue?vue&type=script&lang=js&"
export * from "./LayoutTextList.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTextList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports